"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseThreadSettingsInput = exports.parseTransactionInstruction = exports.parseTransactionInstructions = void 0;
const anchor_1 = require("@coral-xyz/anchor");
function parseTransactionInstructions(instructions) {
    let _instructions = [];
    instructions.forEach((instruction) => {
        _instructions.push(parseTransactionInstruction(instruction));
    });
    return _instructions;
}
exports.parseTransactionInstructions = parseTransactionInstructions;
function parseTransactionInstruction(instruction) {
    return {
        programId: instruction.programId,
        accounts: instruction.keys,
        data: instruction.data,
    };
}
exports.parseTransactionInstruction = parseTransactionInstruction;
function parseThreadSettingsInput(settings) {
    return {
        fee: settings.fee ? new anchor_1.BN(settings.fee) : null,
        rateLimit: settings.rateLimit ? new anchor_1.BN(settings.rateLimit) : null,
        instructions: settings.instructions ? settings.instructions : null,
        name: settings.name ? settings.name : null,
        trigger: settings.trigger ? settings.trigger : null,
    };
}
exports.parseThreadSettingsInput = parseThreadSettingsInput;
